import React, { useEffect, useState } from "react";
import {
  Paper,
  makeStyles,
  Box,
  alpha,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Button,
  TextField,
  InputAdornment,
  Typography,
  Select,
  MenuItem,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import { useDispatch, useSelector } from "react-redux";
import { getTrust } from "../../store/action";
import history from "../../utils/HistoryUtils";
import EnhancedTableHead from "./EnhancedTableHead";
import { headCells } from "./Headcells";
import { Visibility } from "@material-ui/icons";
import Loading from "../../components/Loading/Loading";
import TablePaginationControls from "../../components/TablePaginationControls";
import { Link as RouterLink } from 'react-router-dom';
import MuiLink from '@mui/material/Link';
import moment from "moment/moment";
const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: 20,
    marginTop: theme.spacing(3),
    background: theme.palette.background.main
  },
  container: {
    marginTop: "15px",
    maxHeight: "calc(100vh - 260px)",
    overflowX: "hidden",
    [theme.breakpoints.down('sm')]: {
      overflowX: 'auto',
    },
  },

  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
    },
    marginLeft: 0,
    width: "100%",
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(),
      width: "auto",
    },
  },
  searchIcon: {
    width: theme.spacing(6),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  inputInput: {
    paddingTop: theme.spacing(),
    paddingRight: theme.spacing(),
    paddingBottom: theme.spacing(),
    paddingLeft: theme.spacing(1),
    transition: theme.transitions.create("width"),
    width: "100%",
    borderBottom: "1px solid #ccc",
    [theme.breakpoints.up("md")]: {
      width: 200,
    },
  },
  viewBtn: {
    display: "flex",
    alignItems: "center",
  },
  compactCell: {
    padding: '8px 16px',
    color: theme.palette.listItem
  },
}));

const ViewTrust = ({ match }) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [searchData, setSearchData] = useState({ search: "", id: "" });
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));

  const { getTrustItem, loading } = useSelector((state) => state.trust);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));

  const getTrustList = (
    pageNo = 1,
    perPage = 15,
    search = "",
    type = order,
    column_name = orderBy
  ) => {
    dispatch(getTrust({ pageNo, perPage, search, type, column_name }));
  };

  const onhandlClick = (id) => {
    history.push(`${match.url}/${id}/detail`);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
    getTrustList(value, perPage, searchData.search);
  };

  const handlePerPageChange = (event) => {
    const newPerPage = event.target.value;
    setPerPage(newPerPage);
    setPage(1); // Reset to first page when changing items per page
    getTrustList(1, newPerPage, searchData.search);
  };

  const handleSearchChange = (event) => {
    const d1 = event.target.value;
    setSearchData({ ...searchData, [event.target.name]: d1 });

    if (d1) {
      setTimeout(() => getTrustList(page, perPage, d1), 100);
    } else {
      setTimeout(() => getTrustList(page, perPage, ""), 100);
    }
  };

  const handleClickSearch = () => {
    getTrustList(page, perPage, searchData.search);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    getTrustList(page, perPage, searchData.search);
  }, [orderBy, order]);

  const navigate = (url) => {
    history.push(url);
  };

  return (
    <>
      {loading && <Loading open={loading} />}

      <Paper className={`${classes.root} mb-6`}>
        <Box className="mb-5" display="flex" alignItems="center">
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <TextField
              name="search"
              variant="outlined"
              placeholder="Search..."
              value={searchData.search}
              onChange={handleSearchChange}
              onKeyPress={(e) => e.key === "Enter" && handleClickSearch()}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      style={{
                        color: "#856f6f",
                        cursor: "pointer",
                      }}
                      onClick={handleClickSearch}
                    />
                  </InputAdornment>
                ),
              }}
              className="modernSearchField"
              size="small"
            />
          </div>
          {staffDetail !== "Booking" && staffDetail !== "Finance" &&
            ((loginUserInfo?.role === "STAFF" &&
              loginUserInfo?.permissions?.some(p => p.toLowerCase() === "customers-create")) ||
              (loginUserInfo?.role !== "STAFF")) && (
              <div className="ml-5">
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => navigate(`${match.url}/create`)}
                  size="small"
                >
                  <AddIcon className="mr-2" />
                  Add Customer
                </Button>
              </div>
            )}
        </Box>

        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={(event, property) => {
                handleRequestSort(property);
              }}
              rowCount={getTrustItem?.data?.data?.length}
              headCells={headCells[0]}
            />

            <TableBody>
              {getTrustItem?.data?.data &&
                getTrustItem?.data?.data.map((list, index) => {
                  return (
                    <TableRow key={index} hover>
                      <TableCell scope="row" className={classes.compactCell}>
                        {getTrustItem?.data?.from + index}
                      </TableCell>
                      <TableCell align="left" className={classes.compactCell}>
                        <MuiLink
                          component={
                            (loginUserInfo?.role === "STAFF" &&
                              loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "customers-view")) ||
                              loginUserInfo?.role !== "STAFF" ? RouterLink : "span"
                          }
                          to="#"
                          onClick={(e) => {
                            if ((loginUserInfo?.role === "STAFF" &&
                              loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "customers-view")) ||
                              loginUserInfo?.role !== "STAFF") {
                              e.preventDefault();
                              onhandlClick(list.id)
                            } else {
                              e.preventDefault();
                            }
                          }}
                          underline="hover"
                          sx={{
                            cursor: (loginUserInfo?.role === "STAFF" &&
                              loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "customers-view")) || (loginUserInfo?.role !== "STAFF") ? "pointer" : "not-allowed",
                            color: "#3e81c3"

                          }}
                          className="clickableLink"
                        >
                          {list.name}
                        </MuiLink>
                      </TableCell>
                      <TableCell scope="row" className={classes.compactCell}>
                        {list?.code ?? "-"}
                      </TableCell>
                      <TableCell scope="row" className={classes.compactCell}>
                        {list?.framework ?? "-"}
                      </TableCell>
                      <TableCell scope="row" className={classes.compactCell}>
                        {list?.updated_by_name ?? "-"}
                      </TableCell>
                      <TableCell scope="row" className={classes.compactCell}>
                        {list?.updated_at
                          ? moment(list.updated_at).format("DD-MMM-YYYY")
                          : "-"}
                      </TableCell>
                      {/* <TableCell align="center" className={classes.compactCell} style={{ width: 100 }}>
                        {((loginUserInfo?.role === "STAFF" &&
                          loginUserInfo?.permissions?.some(p => p.toLowerCase() === "Customers-view")) || 
                          (loginUserInfo?.role !== "STAFF")) && (
                            <Box
                              onClick={() => onhandlClick(list.id)}
                              variant="outlined"
                              size="small"
                              color="primary"
                              style={{ cursor: "pointer" }}
                            >
                              <Visibility variant="outlined" size="small" />
                            </Box>
                          )}
                      </TableCell> */}
                    </TableRow>
                  );
                })}

              {(!getTrustItem?.data?.data || getTrustItem?.data?.data.length === 0) && (
                <TableRow>
                  <TableCell align="center" colSpan="6" className={classes.compactCell}>
                    No customers found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePaginationControls
          page={page}
          rowsPerPage={perPage}
          totalRecords={getTrustItem?.data?.total}
          onPageChange={handleChangePage}
          handlePerPageChange={handlePerPageChange}
        />
      </Paper>
    </>
  );
};

export default ViewTrust;